import React from 'react';
import { Fuel, Edit2, Trash2, DollarSign, Droplet } from 'lucide-react';

const FuelPurchaseList = ({ fuelPurchases, onEdit, onDelete }) => {
  if (!fuelPurchases || fuelPurchases.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        <Fuel className="w-12 h-12 mx-auto mb-3 text-gray-300" />
        <p>No fuel purchases recorded for this day</p>
      </div>
    );
  }

  const totalFuelCost = fuelPurchases.reduce((sum, fp) => sum + (fp.amountSpent || 0), 0);

  return (
    <div className="space-y-4">
      {/* Total Summary */}
      <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <Fuel className="w-6 h-6 text-orange-600" />
          <div>
            <div className="text-sm text-gray-600">Total Fuel Cost</div>
            <div className="text-2xl font-bold text-gray-900">${totalFuelCost.toFixed(2)}</div>
          </div>
        </div>
        <div className="text-sm text-gray-600">
          {fuelPurchases.length} {fuelPurchases.length === 1 ? 'purchase' : 'purchases'}
        </div>
      </div>

      {/* Fuel Purchase Cards */}
      <div className="space-y-3">
        {fuelPurchases.map((fp) => (
          <div
            key={fp.id}
            className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
          >
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center space-x-3 mb-2">
                  <div className="flex items-center space-x-2">
                    <Fuel className="w-5 h-5 text-orange-600" />
                    <span className="font-semibold text-gray-900">{fp.stationName}</span>
                  </div>
                  <span className="text-sm text-gray-500">{fp.time}</span>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
                  <div>
                    <div className="text-gray-500 text-xs">Amount Spent</div>
                    <div className="font-semibold text-gray-900 flex items-center">
                      <DollarSign className="w-4 h-4" />
                      {fp.amountSpent.toFixed(2)}
                    </div>
                  </div>

                  {fp.gallons && (
                    <div>
                      <div className="text-gray-500 text-xs">Gallons</div>
                      <div className="font-semibold text-gray-900 flex items-center">
                        <Droplet className="w-4 h-4 mr-1" />
                        {fp.gallons.toFixed(2)}
                      </div>
                    </div>
                  )}

                  {fp.liters && (
                    <div>
                      <div className="text-gray-500 text-xs">Liters</div>
                      <div className="font-semibold text-gray-900 flex items-center">
                        <Droplet className="w-4 h-4 mr-1" />
                        {fp.liters.toFixed(2)}
                      </div>
                    </div>
                  )}

                  <div>
                    <div className="text-gray-500 text-xs">Payment</div>
                    <div className="font-semibold text-gray-900">{fp.paymentMethod}</div>
                  </div>
                </div>

                {fp.notes && (
                  <div className="mt-2 text-sm text-gray-600 italic">
                    Note: {fp.notes}
                  </div>
                )}
              </div>

              <div className="flex space-x-2 ml-4">
                <button
                  onClick={() => onEdit(fp)}
                  className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                  title="Edit"
                >
                  <Edit2 className="w-4 h-4" />
                </button>
                <button
                  onClick={() => onDelete(fp.id)}
                  className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                  title="Delete"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FuelPurchaseList;
